import React from 'react';
import { AbstractComponentBuilder, ComponentSettingsLlm } from '@report-content';
import Llm from './Llm';
import LlmEditPanel from './LlmEditPanel';

export default class LlmComponentBuilder extends AbstractComponentBuilder<ComponentSettingsLlm> {
    getComponent(editPanel?: any) {
        return (
            <Llm
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
                editPanel={editPanel}
                blockId={this.block.uid}
            />
        );
    }

    getEditPanel() {
        if (this.contentSettings.context == 'view') {
            return null;
        }
        return (
            <LlmEditPanel
                block={this.block}
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }
}
